module.exports = __webpack_public_path__ + "static/carousel-hero-web-2582efc8415f6c09de3ef4a345694449.png";